import React, { useState } from 'react';
import { products } from '../mock'; 
import { Download, ShoppingBag, X, ZoomIn } from 'lucide-react';

export const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [zoomedImage, setZoomedImage] = useState(null);

  const categories = ['All', 'Fashion', 'Lifestyle', 'Accessories'];

  const filteredProducts = selectedCategory === 'All'
    ? products
    : products.filter(p => p.category === selectedCategory);

  return (
    <>
      <div className="min-h-screen pt-24 pb-16 font-body text-stone-700 bg-[var(--caramel)]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold font-heading mb-4" style={{ color: 'var(--rufous)' }}>
              Our Products
            </h1>
            <p className="text-base sm:text-lg text-stone-700 max-w-3xl mx-auto mb-8">
              Each product transforms heritage into modern, functional beauty. 
              From fashion to lifestyle, carry a piece of Dayak culture with you.
            </p>
            <div className="w-24 h-1 mx-auto" style={{ backgroundColor: 'var(--uc-gold)' }}></div>
          </div>

          {/* --- KARTU KATALOG SEBELUMNYA SUDAH DIHAPUS DARI SINI --- */}
          
          {/* Category Filter */}
          <div className="flex flex-wrap gap-3 justify-center mb-12">
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-semibold font-heading transition-all duration-300 ${
                  selectedCategory === category
                    ? 'text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:shadow-md'
                }`}
                style={{
                  backgroundColor: selectedCategory === category ? 'var(--uc-gold)' : 'white',
                  borderColor: selectedCategory === category ? 'var(--uc-gold)' : '#e5e7eb',
                  borderWidth: '2px',
                }}
              >
                {category}
              </button>
            ))}
          </div>

          {/* --- Tombol Download Catalog (Simple) --- */}


          {/* Products Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredProducts.map(product => (
              <div
                key={product.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg transform transition-all duration-300 hover:scale-[1.02] flex flex-col"
              >
                <div 
                  className="aspect-square overflow-hidden bg-gray-100 cursor-zoom-in relative group"
                  onClick={() => setZoomedImage(product.image || product.images?.[0])}
                >
                  <img
                    src={product.image || product.images?.[0]}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <ZoomIn className="w-10 h-10 text-white" />
                  </div>
                </div>
                <div className="p-5 flex-grow">
                  <span
                    className="inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3"
                    style={{ backgroundColor: 'var(--caramel)', color: 'var(--army-green)' }}
                  >
                    {product.category}
                  </span>
                  <h3 className="text-lg font-bold font-heading mb-2" style={{ color: 'var(--rufous)' }}>
                    {product.name}
                  </h3>
                  <p className="text-sm text-stone-700 line-clamp-3">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Collection Sections */}
          <div className="mt-20 space-y-16">
            <div className="text-center">
              <h2 className="text-3xl font-bold font-heading mb-4" style={{ color: 'var(--army-green)' }}>
                Woven Heritage Collection
              </h2>
              <p className="text-lg text-stone-700 max-w-2xl mx-auto">
                Fashion × Tradition — Ancient heritage meets modern creativity
              </p>
            </div>
          </div>
                    {/* Ditempatkan di sini, "di bawah" filter */}
          <div className="text-center mt-8 mb-12">
            <a
              href="https://ik.imagekit.io/dandie/sapuyung%20dare/KatalogUMKM_Marajaki_Kreatif.pdf?updatedAt=1762467084741"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold text-white transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              style={{ backgroundColor: 'var(--rufous)' }}
            >
              <Download className="w-5 h-5" />
              <span>Download Complete Catalog</span>
            </a>
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 text-center p-8 rounded-xl" style={{ backgroundColor: 'var(--caramel)' }}>
            <ShoppingBag className="w-12 h-12 mx-auto mb-4" style={{ color: 'var(--rufous)' }} />
            <h3 className="text-2xl font-bold font-heading mb-3" style={{ color: 'var(--army-green)' }}>
              Interested in Our Products?
            </h3>
            <p className="text-base text-stone-800 mb-6">
              Get in touch for custom orders, collaborations, or inquiries.
            </p>
            <a
              href="/contact"
              className="inline-flex items-center space-x-2 px-8 py-3 rounded-lg font-semibold text-white transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              style={{ backgroundColor: 'var(--rufous)' }}
            >
              <span>Contact Us</span>
            </a>
          </div>
        </div>
      </div>

      {/* Modal Lightbox (Zoom) */}
      {zoomedImage && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 transition-opacity duration-300 animate-fade-in"
          onClick={() => setZoomedImage(null)} // Menutup saat klik overlay
        >
          {/* Tombol Close */}
          <button
            className="absolute top-4 right-4 z-[110] text-white/80 hover:text-white transition-colors"
            onClick={() => setZoomedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          
          {/* Kontainer Gambar (mencegah penutupan saat klik gambar) */}
          <div 
            className="relative"
            onClick={(e) => e.stopPropagation()} // Mencegah overlay tertutup saat klik gambar
          >
            <img
              src={zoomedImage}
              alt="Zoomed Product"
              className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
          </div>
        </div>
      )}
    </>
  );
};